module.exports = __webpack_public_path__ + "img/exit_17.1e16dbf4.svg";